(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Twinbed"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('restora-kids-reference')) {
    class RestoraKidsReference extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.items = [...this.querySelectorAll('.na-reveal')];
        this.panels = [...this.querySelectorAll('[data-na-parallax]')].filter(panel => panel.querySelector(':scope > img'));
        this.requestFrame = this.requestFrame.bind(this);
        this.setupMotion = this.setupMotion.bind(this);
        this.setupMotion();
        window.addEventListener('scroll', this.requestFrame, { passive: true, signal });
        window.addEventListener('resize', this.requestFrame, { passive: true, signal });
        this.motionQuery.addEventListener('change', this.setupMotion, { signal });
        this.querySelectorAll('.na-faq-item').forEach(item => item.addEventListener('toggle', () => {
          if (item.open) this.querySelectorAll('.na-faq-item').forEach(other => { if (other !== item) other.open = false; });
        }, { signal }));
        document.addEventListener('shopify:block:select', event => {
          if (!(event.target instanceof Element) || !this.contains(event.target)) return;
          event.target.closest('.na-reveal')?.classList.add('is-visible');
        }, { signal });
        if ('ResizeObserver' in window) { this.resizeObserver = new ResizeObserver(this.requestFrame); this.resizeObserver.observe(this); }
        this.requestFrame();
      }
      setupMotion() {
        this.observer?.disconnect();
        this.motion = this.dataset.motion === 'true' && !this.motionQuery.matches;
        if (!this.motion || !('IntersectionObserver' in window) || window.Shopify?.designMode) {
          this.classList.remove('is-animated');
          this.items.forEach(item => item.classList.add('is-visible'));
        } else {
          this.classList.add('is-animated');
          this.observer = new IntersectionObserver(entries => entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            this.observer.unobserve(entry.target);
          }), { threshold: .12, rootMargin: '0px 0px -5% 0px' });
          this.items.forEach(item => this.observer.observe(item));
        }
        this.requestFrame();
      }
      requestFrame() {
        if (this.frame || !this.isConnected) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          if (!this.motion) return;
          this.panels.forEach(panel => {
            const rect = panel.getBoundingClientRect();
            if (rect.bottom < 0 || rect.top > innerHeight) return;
            const speed = parseFloat(panel.dataset.naSpeed || '.06');
            const offset = innerHeight / 2 - (rect.top + rect.height / 2);
            const limit = Math.min(28, rect.height * .07);
            panel.style.setProperty('--na-shift', `${Math.max(-limit, Math.min(limit, offset * speed)).toFixed(2)}px`);
          });
        });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.controller = null;
        this.frame = null;
        this.classList.remove('is-animated');
      }
    }
    customElements.define('restora-kids-reference', RestoraKidsReference);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["allinone"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('restora-plunge')) {
  customElements.define('restora-plunge', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      try { this.config = JSON.parse(this.querySelector('[data-rp-config]').textContent); }
      catch { return; }
      this.controller = new AbortController();
      this.signal = this.controller.signal;
      this.observers = [];
      this.timers = new Set();
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.variant = this.config.variants.find(v => v.id === this.config.initialVariant) || this.config.variants[0];
      this.tabs = Array.from(this.querySelectorAll('[data-rp-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-rp-panel]'));
      this.navLinks = Array.from(this.querySelectorAll('[data-rp-nav]'));
      this.cart = this.querySelector('[data-rp-cart]');
      this.initTabs();
      this.initMotion();
      this.findMainForm();
      this.on(this, 'click', event => this.onClick(event));
      this.on(this, 'input', event => {
        if (event.target.matches('[data-rp-frequency]')) this.updateValue();
      });
      this.on(this, 'change', event => {
        if (event.target.matches('[data-rp-check]')) this.updateChecks();
        if (event.target.matches('[data-rp-frequency]')) this.emit('routine_changed');
      });
      this.on(document, 'change', () => this.scheduleSync());
      ['variant:change','variant:changed','product:variant-change','shopify:section:load'].forEach(name => this.on(document, name, () => this.scheduleSync()));
      this.on(window, 'popstate', () => this.scheduleSync());
      this.on(window, 'scroll', () => this.requestFrame(), { passive: true });
      this.on(window, 'resize', () => this.requestFrame(), { passive: true });
      this.on(document, 'shopify:block:select', event => {
        const block = event.target.closest('.rp-section');
        if (block && this.contains(block)) {
          block.querySelectorAll('[data-rp-reveal]').forEach(el => el.classList.add('rp-visible'));
        }
      });
      this.syncVariant();
      this.updateChecks();
      this.requestFrame();
    }
    on(target, name, callback, options = {}) {
      target.addEventListener(name, callback, { ...options, signal: this.signal });
    }
    later(callback, delay) {
      const timer = setTimeout(() => { this.timers.delete(timer); callback(); }, delay);
      this.timers.add(timer);
      return timer;
    }
    scheduleSync() {
      if (this.syncTimer) { clearTimeout(this.syncTimer); this.timers.delete(this.syncTimer); }
      this.syncTimer = this.later(() => { this.syncTimer = null; this.syncVariant(); }, 100);
    }
    initTabs() {
      if (!this.tabs.length) return;
      this.querySelector('[data-rp-tabs]').hidden = false;
      this.activateTab(this.tabs[0], false);
      this.tabs.forEach(tab => this.on(tab, 'keydown', event => {
        const index = this.tabs.indexOf(tab);
        let next;
        if (event.key === 'ArrowRight') next = this.tabs[(index + 1) % this.tabs.length];
        if (event.key === 'ArrowLeft') next = this.tabs[(index - 1 + this.tabs.length) % this.tabs.length];
        if (event.key === 'Home') next = this.tabs[0];
        if (event.key === 'End') next = this.tabs[this.tabs.length - 1];
        if (next) { event.preventDefault(); this.activateTab(next, false); next.focus(); }
      }));
    }
    activateTab(tab, animate) {
      const change = () => {
        this.tabs.forEach(item => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });
        this.panels.forEach(panel => { panel.hidden = panel.dataset.rpPanel !== tab.dataset.rpTab; });
      };
      if (animate && this.dataset.motion === 'true' && !this.reduced.matches && document.startViewTransition) {
        if (this.transition) this.transition.skipTransition();
        this.transition = document.startViewTransition(change);
        this.transition.finished.catch(() => {}).finally(() => { this.transition = null; });
      } else change();
      if (animate) this.emit('feature_' + tab.dataset.rpTab);
    }
    initMotion() {
      if (this.dataset.motion !== 'true' || this.reduced.matches || !('IntersectionObserver' in window)) return;
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('rp-visible'); observer.unobserve(entry.target); }
      }), { threshold: 0.04, rootMargin: '0px 0px 70px 0px' });
      this.querySelectorAll('[data-rp-reveal]').forEach(el => observer.observe(el));
      this.observers.push(observer);
      this.classList.add('rp--motion');
      this.on(this.reduced, 'change', event => {
        if (event.matches) {
          this.classList.remove('rp--motion');
          observer.disconnect();
        }
      });
    }
    findMainForm() {
      let candidates = [];
      if (this.dataset.formSelector) {
        try { candidates = Array.from(document.querySelectorAll(this.dataset.formSelector)); } catch {}
      }
      if (!candidates.length) candidates = Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
      const ids = new Set(this.config.variants.map(v => String(v.id)));
      const form = candidates.find(el => el.tagName === 'FORM' && !this.contains(el) && ids.has(el.querySelector('[name="id"]')?.value));
      if (form === this.mainForm) return;
      if (this.formObserver) this.formObserver.disconnect();
      this.mainForm = form || null;
      this.mainButton = this.mainForm?.querySelector('button[name="add"],button[type="submit"],input[type="submit"]');
      if (this.mainForm) {
        this.formObserver = new MutationObserver(() => this.scheduleSync());
        this.formObserver.observe(this.mainForm.closest('.shopify-section') || this.mainForm, { subtree: true, childList: true, attributes: true, attributeFilter: ['value','disabled','aria-disabled'] });
      }
    }
    syncVariant() {
      this.findMainForm();
      const input = this.mainForm?.querySelector('[name="id"]');
      const urlId = new URL(window.location.href).searchParams.get('variant');
      const currentId = input?.value || urlId || this.config.initialVariant;
      const next = this.config.variants.find(v => String(v.id) === String(currentId));
      if (next) this.variant = next;
      this.mainButton = this.mainForm?.querySelector('button[name="add"],button[type="submit"],input[type="submit"]');
      this.querySelectorAll('[data-rp-price]').forEach(el => { el.textContent = this.money(this.variant?.price || 0); });
      const canAdd = this.mainForm && this.mainButton && this.variant?.available && !this.mainButton.disabled && this.mainButton.getAttribute('aria-disabled') !== 'true';
      const label = canAdd ? this.config.labels.add : this.variant?.available ? this.config.labels.options : this.config.labels.unavailable;
      this.querySelectorAll('[data-rp-purchase]').forEach(el => {
        el.firstChild.textContent = label + ' ';
        el.href = this.config.productUrl + (this.variant ? '?variant=' + this.variant.id : '');
      });
      this.updateValue();
      this.requestFrame();
    }
    money(cents) {
      try { return new Intl.NumberFormat(this.config.locale || 'en', { style: 'currency', currency: this.config.currency || 'USD' }).format(cents / 100); }
      catch { return (cents / 100).toFixed(2) + ' ' + (this.config.currency || 'USD'); }
    }
    updateValue() {
      const input = this.querySelector('[data-rp-frequency]');
      if (!input) return;
      const frequency = Math.max(1, Math.min(7, Number(input.value) || 3));
      const sessions = frequency * 52;
      this.querySelector('[data-rp-frequency-label]').textContent = frequency;
      this.querySelector('[data-rp-session-price]').textContent = this.money((this.variant?.price || 0) / sessions);
      this.querySelector('[data-rp-year]').textContent = this.config.labels.year.replace('__COUNT__', sessions);
    }
    updateChecks() {
      const checks = this.querySelectorAll('[data-rp-check]');
      const count = Array.from(checks).filter(input => input.checked).length;
      const text = this.querySelector('[data-rp-check-count]');
      const progress = this.querySelector('[data-rp-check-progress]');
      if (text) text.textContent = this.config.labels.checks.replace('__COUNT__', count);
      if (progress) progress.value = count;
    }
    onClick(event) {
      const tab = event.target.closest('[data-rp-tab]');
      if (tab && this.contains(tab)) { this.activateTab(tab, true); return; }
      const purchase = event.target.closest('[data-rp-purchase]');
      if (purchase && this.contains(purchase)) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        this.syncVariant();
        if (!this.mainForm || !this.mainButton) return;
        event.preventDefault();
        const disabled = this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true';
        if (this.variant?.available && !disabled && this.mainForm.checkValidity()) {
          this.mainButton.click();
          this.emit('native_add_to_cart');
        } else {
          this.mainForm.scrollIntoView({ behavior: this.reduced.matches ? 'auto' : 'smooth', block: 'center' });
          this.mainForm.reportValidity();
          const focusable = this.mainForm.querySelector('select,input:not([type="hidden"]):not(:disabled),button:not(:disabled)');
          focusable?.focus({ preventScroll: true });
          this.emit('purchase_options');
        }
        return;
      }
      const nav = event.target.closest('[data-rp-nav]');
      if (nav && this.contains(nav)) {
        const target = this.querySelector(nav.getAttribute('href'));
        if (target) { event.preventDefault(); target.scrollIntoView({ behavior: this.reduced.matches ? 'auto' : 'smooth', block: 'start' }); }
      }
    }
    requestFrame() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = null; this.updateScroll(); });
    }
    updateScroll() {
      const rect = this.getBoundingClientRect();
      const offset = Number.parseInt(getComputedStyle(this).getPropertyValue('--rp-offset'), 10) || 0;
      const progress = this.querySelector('[data-rp-progress]');
      const distance = Math.max(1, this.offsetHeight - window.innerHeight);
      if (progress) progress.style.transform = 'scaleX(' + Math.min(1, Math.max(0, (offset - rect.top) / distance)) + ')';
      let active = null;
      this.navLinks.forEach(link => {
        const target = this.querySelector(link.getAttribute('href'));
        if (target && target.getBoundingClientRect().top <= offset + 150) active = link;
      });
      this.navLinks.forEach(link => {
        if (link === active) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
      if (this.cart) {
        const formRect = this.mainForm?.getBoundingClientRect();
        const isVisible = Boolean(formRect && formRect.bottom < offset && rect.top < window.innerHeight && rect.bottom > 160);
        this.cart.hidden = !isVisible;
        this.classList.toggle('rp--cart-visible', isVisible);
      }
    }
    emit(action) {
      this.dispatchEvent(new CustomEvent('restora:plunge_engagement', { bubbles: true, detail: { action, variantId: this.variant?.id || null } }));
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observers?.forEach(observer => observer.disconnect());
      this.formObserver?.disconnect();
      this.timers?.forEach(timer => clearTimeout(timer));
      if (this.frame) cancelAnimationFrame(this.frame);
      this.transition?.skipTransition();
      this.querySelectorAll('video').forEach(video => video.pause());
      this.ready = false;
      this.mainForm = null;
      this.frame = null;
      this.syncTimer = null;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["allinonecoldplunge"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('restora-plunge')) {
    class RestoraPlunge extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.abort = new AbortController();
        this.frames = new Set();
        this.counterFrames = new Set();
        this.visibleMedia = new Set();
        this.userPausedVideos = new WeakSet();
        this.autoPauseVideos = new WeakSet();
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.reduced.matches;
        this.locale = document.documentElement.lang || 'en-US';
        this.rootSeen = false;
        this.variants = [];
        try { this.variants = JSON.parse(this.querySelector('[data-rp-variants]')?.textContent || '[]') || []; } catch (_) { this.variants = []; }
        this.on(window, 'scroll', () => this.scheduleUpdate(), { passive: true });
        this.on(window, 'resize', () => { this.setWidth(); this.scheduleUpdate(); }, { passive: true });
        this.on(this.reduced, 'change', () => { this.setPaused(this.reduced.matches); this.scheduleUpdate(); });
        this.on(this, 'click', (event) => this.handleClick(event));
        this.on(this, 'keydown', (event) => this.handleKeys(event));
        this.on(document, 'change', () => this.syncVariant());
        this.on(document, 'visibilitychange', () => {
          this.visibleMedia.forEach((media) => {
            const video = media.querySelector('video');
            if (!video) return;
            if (document.hidden) this.pauseVideo(video, true);
            else if (this.canAutoplay(media, video)) this.playVideo(video);
          });
        });
        ['variant:change', 'variant:changed', 'product:variant-change'].forEach((name) => this.on(document, name, () => this.syncVariant()));
        this.on(document, 'shopify:block:select', (event) => {
          const block = Array.from(this.querySelectorAll('[data-rp-block]')).find((item) => item.dataset.blockId === event.detail?.blockId);
          if (block) { block.querySelectorAll('.rp-reveal').forEach((item) => item.classList.add('is-visible')); block.scrollIntoView({ block: 'center', behavior: 'auto' }); }
        });
        this.setWidth();
        this.setupTabs();
        this.setupFaqs();
        this.setupVideos();
        this.setupObservers();
        this.setPaused(this.paused);
        this.syncVariant();
        this.scheduleUpdate();
      }
      on(target, name, callback, options = {}) { target?.addEventListener(name, callback, { ...options, signal: this.abort.signal }); }
      setWidth() { this.style.setProperty('--rp-viewport', document.documentElement.clientWidth + 'px'); }
      setupObservers() {
        if (!('IntersectionObserver' in window)) {
          this.querySelectorAll('.rp-reveal').forEach((item) => item.classList.add('is-visible'));
          return;
        }
        if (this.dataset.reveal === 'true' && !this.paused && this.dataset.designMode !== 'true') {
          this.classList.add('rp-enhanced');
          this.revealObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); this.revealObserver.unobserve(entry.target); } });
          }, { threshold: 0.08, rootMargin: '0px 0px -25px 0px' });
          this.querySelectorAll('.rp-reveal').forEach((item) => this.revealObserver.observe(item));
        }
        this.mediaObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const video = entry.target.querySelector('video');
            if (entry.isIntersecting) {
              this.visibleMedia.add(entry.target);
              if (video && this.canAutoplay(entry.target, video)) this.playVideo(video);
            } else {
              this.visibleMedia.delete(entry.target);
              if (video && !video.paused) this.pauseVideo(video, true);
            }
          });
          this.scheduleUpdate();
        }, { threshold: 0.2 });
        this.querySelectorAll('[data-rp-media]').forEach((item) => this.mediaObserver.observe(item));
        this.rootObserver = new IntersectionObserver((entries) => {
          this.rootSeen = entries[0].isIntersecting;
          if (this.rootSeen && !this.variantTimer) this.variantTimer = setInterval(() => this.syncVariant(), 900);
          if (!this.rootSeen && this.variantTimer) { clearInterval(this.variantTimer); this.variantTimer = null; }
          this.scheduleUpdate();
        }, { threshold: 0 });
        this.rootObserver.observe(this);
        this.countObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => { if (entry.isIntersecting) { this.animateCount(entry.target); this.countObserver.unobserve(entry.target); } });
        }, { threshold: 0.5 });
        this.querySelectorAll('[data-rp-count]').forEach((item) => this.countObserver.observe(item));
      }
      setPaused(value) {
        this.paused = Boolean(value);
        this.classList.toggle('rp-paused', this.paused);
        this.classList.toggle('rp-motion-ready', !this.paused && this.dataset.motion === 'true');
        const button = this.querySelector('[data-rp-motion-toggle]');
        if (button) { button.setAttribute('aria-pressed', String(this.paused)); button.textContent = this.paused ? button.dataset.resume : button.dataset.pause; }
        this.querySelectorAll('[data-rp-media] video').forEach((video) => {
          const media = video.closest('[data-rp-media]');
          video.controls = media.dataset.rpControls === 'true' || media.dataset.rpAutoplay !== 'true' || !video.muted || this.dataset.autoplay !== 'true' || this.paused;
        });
        if (this.paused) {
          this.querySelectorAll('[data-rp-count]').forEach((item) => { item.textContent = item.dataset.rpCount; });
          this.counterFrames.forEach((id) => cancelAnimationFrame(id));
          this.counterFrames.clear();
          this.querySelectorAll('[data-rp-media] video').forEach((video) => { if (video.closest('[data-rp-media]')?.dataset.rpAutoplay === 'true') this.pauseVideo(video, true); });
          this.querySelectorAll('.rp-reveal').forEach((item) => item.classList.add('is-visible'));
        } else {
          this.visibleMedia.forEach((media) => { const video = media.querySelector('video'); if (video && this.canAutoplay(media, video)) this.playVideo(video); });
        }
        this.scheduleUpdate();
      }
      scheduleUpdate() {
        if (this.updateFrame) return;
        this.updateFrame = requestAnimationFrame(() => { this.updateFrame = null; this.updateScroll(); });
      }
      updateScroll() {
        const rect = this.getBoundingClientRect();
        const viewport = window.innerHeight;
        const progress = Math.min(1, Math.max(0, -rect.top / Math.max(1, rect.height - viewport)));
        const meter = this.querySelector('[data-rp-progress]');
        if (meter) meter.style.setProperty('--rp-progress', String(progress));
        if (!this.paused && this.dataset.motion === 'true') {
          const strength = Math.min(50, Math.max(0, Number(this.dataset.strength) || 0)) / 50;
          this.visibleMedia.forEach((media) => {
            if (media.dataset.rpMotion === 'none' || media.classList.contains('rp-media--contain')) return;
            const bounds = media.getBoundingClientRect();
            const position = Math.min(1, Math.max(-1, (viewport / 2 - (bounds.top + bounds.height / 2)) / ((viewport + bounds.height) / 2)));
            const layer = media.querySelector('[data-rp-motion-layer]');
            if (!layer) return;
            const mode = media.dataset.rpMotion;
            layer.style.setProperty('--rp-pan', (mode === 'zoom' ? 0 : position * bounds.height * 0.12 * strength) + 'px');
            layer.style.setProperty('--rp-zoom', mode === 'pan' ? '1' : String(1 + ((position + 1) / 2) * 0.08 * strength));
          });
        }
        const bar = this.querySelector('[data-rp-purchase-bar]');
        if (bar) {
          const form = this.getMainForm();
          const nativeButton = form?.querySelector('[name="add"], [type="submit"]');
          const buttonBounds = nativeButton?.getBoundingClientRect();
          const mainButtonVisible = buttonBounds && buttonBounds.bottom > 0 && buttonBounds.top < viewport;
          const shouldShow = this.rootSeen && rect.top < viewport * 0.58 && rect.bottom > 0 && !mainButtonVisible;
          bar.hidden = !shouldShow;
        }
        let active = null;
        this.querySelectorAll('[data-rp-nav-link]').forEach((link) => {
          const block = document.getElementById(link.hash.slice(1));
          if (block && block.getBoundingClientRect().top <= viewport * 0.4) active = link;
        });
        this.querySelectorAll('[data-rp-nav-link]').forEach((link) => { link.classList.toggle('is-active', link === active); if (link === active) link.setAttribute('aria-current', 'location'); else link.removeAttribute('aria-current'); });
      }
      animateCount(item) {
        if (this.paused || this.dataset.counters !== 'true' || this.dataset.designMode === 'true') return;
        const raw = item.dataset.rpCount.trim();
        if (!/^-?\d+(\.\d+)?$/.test(raw)) return;
        const target = Number(raw);
        const decimals = Math.min(4, (raw.split('.')[1] || '').length);
        const formatter = new Intl.NumberFormat(this.locale, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
        const duration = Math.min(5000, Math.max(300, Number(this.dataset.duration) || 1400));
        const started = performance.now();
        item.textContent = formatter.format(0);
        const tick = (time) => {
          if (!this.isConnected || this.paused) { item.textContent = raw; return; }
          const fraction = Math.min(1, (time - started) / duration);
          item.textContent = formatter.format(target * (1 - Math.pow(1 - fraction, 3)));
          if (fraction < 1) {
            const id = requestAnimationFrame((next) => { this.counterFrames.delete(id); tick(next); });
            this.counterFrames.add(id);
          } else { item.textContent = formatter.format(target); }
        };
        tick(started);
      }
      setupVideos() {
        this.querySelectorAll('[data-rp-media] video').forEach((video) => {
          const media = video.closest('[data-rp-media]');
          if (media.dataset.rpMuted === 'true') video.muted = true;
          this.on(video, 'play', () => {
            this.userPausedVideos.delete(video);
            const button = media.querySelector('[data-rp-video-toggle]');
            if (button) { button.classList.add('is-playing'); button.setAttribute('aria-label', button.dataset.pause); button.querySelector('span').textContent = button.dataset.pause; }
          });
          this.on(video, 'pause', () => {
            if (this.autoPauseVideos.has(video)) this.autoPauseVideos.delete(video); else this.userPausedVideos.add(video);
            const button = media.querySelector('[data-rp-video-toggle]');
            if (button) { button.classList.remove('is-playing'); button.setAttribute('aria-label', button.dataset.play); button.querySelector('span').textContent = button.dataset.play; }
          });
          this.on(video, 'ended', () => {
            const button = media.querySelector('[data-rp-video-toggle]');
            if (button) { button.classList.remove('is-playing'); button.setAttribute('aria-label', button.dataset.play); button.querySelector('span').textContent = button.dataset.play; }
          });
        });
      }
      canAutoplay(media, video) { return !this.paused && this.dataset.autoplay === 'true' && media.dataset.rpAutoplay === 'true' && video.muted && !this.userPausedVideos.has(video) && !document.hidden; }
      playVideo(video) { const result = video.play(); if (result?.catch) result.catch(() => {}); }
      pauseVideo(video, automatic) { if (video.paused) return; if (automatic) this.autoPauseVideos.add(video); video.pause(); }
      setupTabs() { this.querySelectorAll('[role="tablist"]').forEach((list) => this.activateTab(list.querySelector('[role="tab"]'), false)); }
      activateTab(tab, focus) {
        if (!tab) return;
        const list = tab.closest('[role="tablist"]');
        list.querySelectorAll('[role="tab"]').forEach((item) => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
          const panel = document.getElementById(item.getAttribute('aria-controls'));
          if (panel) panel.hidden = !selected;
        });
        if (focus) tab.focus();
      }
      setupFaqs() {
        this.querySelectorAll('[data-rp-faq-single="true"] details').forEach((detail) => this.on(detail, 'toggle', () => {
          if (!detail.open) return;
          detail.closest('[data-rp-faq-single]').querySelectorAll('details').forEach((other) => { if (other !== detail) other.open = false; });
        }));
      }
      handleKeys(event) {
        const tab = event.target.closest('[role="tab"]');
        if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const tabs = Array.from(tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]'));
        let next = tabs.indexOf(tab);
        if (event.key === 'ArrowRight') next = (next + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (next - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        this.activateTab(tabs[next], true);
      }
      handleClick(event) {
        const motionButton = event.target.closest('[data-rp-motion-toggle]');
        if (motionButton) { this.setPaused(!this.paused); return; }
        const videoButton = event.target.closest('[data-rp-video-toggle]');
        if (videoButton) { const video = videoButton.closest('[data-rp-media]').querySelector('video'); if (video.paused) this.playVideo(video); else this.pauseVideo(video, false); return; }
        const tab = event.target.closest('[role="tab"]');
        if (tab) { this.activateTab(tab, false); return; }
        const nav = event.target.closest('[data-rp-nav-link]');
        if (nav) { const target = document.getElementById(nav.hash.slice(1)); if (target) { event.preventDefault(); target.scrollIntoView({ behavior: this.paused ? 'auto' : 'smooth', block: 'start' }); } return; }
        const purchase = event.target.closest('[data-rp-purchase]');
        if (!purchase || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (purchase.getAttribute('aria-disabled') === 'true') { event.preventDefault(); return; }
        const form = this.getMainForm();
        if (!form) return;
        event.preventDefault();
        const submit = form.querySelector('[name="add"], [type="submit"]');
        if (this.dataset.ctaAction === 'add' && submit && !submit.disabled && form.checkValidity()) { submit.click(); return; }
        form.scrollIntoView({ block: 'center', behavior: this.paused ? 'auto' : 'smooth' });
        const focusTarget = form.querySelector('select, input:not([type="hidden"]), [name="add"], button');
        focusTarget?.focus({ preventScroll: true });
        form.classList.add('rp-product-focus');
        clearTimeout(this.focusTimer);
        this.focusTimer = setTimeout(() => form.classList.remove('rp-product-focus'), 1600);
      }
      getMainForm() {
        const ids = new Set(this.variants.map((item) => String(item.id)));
        const forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
        return forms.find((form) => {
          if (this.contains(form)) return false;
          const id = form.querySelector('[name="id"]')?.value;
          return id && ids.has(String(id)) && (form.offsetWidth > 0 || form.offsetHeight > 0);
        }) || null;
      }
      syncVariant() {
        if (!this.variants.length) return;
        const mainForm = this.getMainForm();
        const id = mainForm?.querySelector('[name="id"]')?.value || new URLSearchParams(window.location.search).get('variant');
        const variant = this.variants.find((item) => String(item.id) === String(id)) || this.variants.find((item) => item.available) || this.variants[0];
        const key = String(variant.id) + ':' + String(variant.available);
        if (this.variantKey === key) return;
        this.variantKey = key;
        this.querySelectorAll('[data-rp-price]').forEach((item) => {
          try { item.textContent = new Intl.NumberFormat(this.locale, { style: 'currency', currency: this.dataset.currency || 'USD' }).format(variant.price / 100); } catch (_) { }
        });
        const button = this.querySelector('[data-rp-sticky-button]');
        if (button) {
          const label = button.querySelector('[data-rp-button-label]');
          label.textContent = variant.available ? button.dataset.label : button.dataset.soldOut;
          button.setAttribute('aria-disabled', String(!variant.available));
        }
        this.querySelectorAll('[data-rp-purchase]').forEach((link) => {
          try { const url = new URL(link.href, window.location.origin); url.searchParams.set('variant', variant.id); link.href = url.href; } catch (_) { }
        });
      }
      disconnectedCallback() {
        this.abort?.abort();
        [this.revealObserver, this.mediaObserver, this.rootObserver, this.countObserver].forEach((observer) => observer?.disconnect());
        if (this.updateFrame) cancelAnimationFrame(this.updateFrame);
        this.counterFrames?.forEach((id) => cancelAnimationFrame(id));
        clearInterval(this.variantTimer);
        clearTimeout(this.focusTimer);
        this.querySelectorAll('video').forEach((video) => video.pause());
        this.initialized = false;
      }
    }
    customElements.define('restora-plunge', RestoraPlunge);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fullbookshelf"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('restora-murphy-page')) {
  customElements.define('restora-murphy-page', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.motion !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.mediaQuery = matchMedia('(prefers-reduced-motion: reduce)');
      this.controller = new AbortController();
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.remove('rm-pending');
              this.observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.05 });
        this.querySelectorAll('.rm-reveal').forEach(el => {
          if (el.getBoundingClientRect().top > innerHeight) el.classList.add('rm-pending');
          this.observer.observe(el);
        });
      }
      const elements = [...this.querySelectorAll('[data-rm-parallax]')];
      const update = () => {
        this.frame = null;
        elements.forEach(el => {
          const box = el.getBoundingClientRect();
          const shift = this.mediaQuery.matches ? 0 : Math.max(-8, Math.min(8, (innerHeight / 2 - box.top - box.height / 2) * .025));
          el.style.setProperty('--rm-shift', shift + 'px');
        });
      };
      const schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(update); };
      window.addEventListener('scroll', schedule, { passive: true, signal: this.controller.signal });
      window.addEventListener('resize', schedule, { passive: true, signal: this.controller.signal });
      this.mediaQuery.addEventListener('change', () => {
        if (this.mediaQuery.matches) this.querySelectorAll('.rm-pending').forEach(el => el.classList.remove('rm-pending'));
        schedule();
      }, { signal: this.controller.signal });
      update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["japanesefloormattress"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('restora-floor-mattress')) {
    customElements.define('restora-floor-mattress', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (!this.isConnected || this.initialized) return;
        this.initialized = true;
        this.events = new AbortController();
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobileQuery = window.matchMedia('(max-width: 989px)');
        this.purchaseForm = this.findPurchaseForm();
        this.purchaseTarget = this.findPurchaseTarget();
        this.addEventListener('click', event => this.onClick(event), { signal: this.events.signal });
        this.motionQuery.addEventListener('change', () => this.setupMotion(), { signal: this.events.signal });
        this.mobileQuery.addEventListener('change', () => this.updatePrompt(), { signal: this.events.signal });
        this.setupMotion();
        this.setupPrompt();
      }

      findPurchaseForm() {
        let variantIds = [];
        try { variantIds = JSON.parse(this.dataset.variantIds || '[]') || []; } catch (_) {}
        const ids = new Set(variantIds.map(String));
        if (!ids.size) return null;
        const forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
        return forms.find(form => {
          if (this.contains(form) || !form.getClientRects().length) return false;
          const variantInput = form.querySelector('[name="id"]');
          return variantInput && ids.has(String(variantInput.value));
        }) || null;
      }

      findPurchaseTarget() {
        const explicitId = (this.dataset.purchaseTarget || '').replace(/^#/, '').trim();
        const explicitTarget = explicitId ? document.getElementById(explicitId) : null;
        if (explicitTarget) return explicitTarget;
        const form = this.purchaseForm;
        if (!form) return null;
        return form.closest('product-info, [data-product-information], .product__info-container, .product-single__meta, .product-single__details, .product__details') || form;
      }

      onClick(event) {
        const link = event.target.closest('[data-rfm-purchase]');
        if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (!this.purchaseTarget?.isConnected) {
          this.purchaseForm = this.findPurchaseForm();
          this.purchaseTarget = this.findPurchaseTarget();
        }
        if (!this.purchaseTarget) return;
        event.preventDefault();
        const target = this.purchaseTarget;
        const offset = parseFloat(getComputedStyle(this).getPropertyValue('--rfm-anchor-offset')) || 120;
        const top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset);
        if (!target.hasAttribute('tabindex') && !target.matches('a, button, input, select, textarea, summary')) {
          target.setAttribute('tabindex', '-1');
          target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
        }
        target.focus({ preventScroll: true });
        window.scrollTo({ top, behavior: this.motionQuery.matches ? 'instant' : 'smooth' });
        if (this.purchasePrompt) this.purchasePrompt.hidden = true;
      }

      setupMotion() {
        this.revealObserver?.disconnect();
        this.classList.remove('rfm--motion');
        if (this.dataset.motion !== 'true' || this.motionQuery.matches || !('IntersectionObserver' in window)) return;
        this.classList.add('rfm--motion');
        this.revealObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('rfm-in-view');
            this.revealObserver.unobserve(entry.target);
          });
        }, { rootMargin: '0px 0px -28px 0px', threshold: 0.06 });
        this.querySelectorAll('[data-rfm-reveal]').forEach(element => this.revealObserver.observe(element));
      }

      setupPrompt() {
        this.purchasePrompt = this.querySelector('[data-rfm-sticky]');
        if (!this.purchasePrompt || !this.purchaseTarget || !('IntersectionObserver' in window)) return;
        document.addEventListener('toggle', () => this.updatePrompt(), { capture: true, signal: this.events.signal });
        document.addEventListener('click', () => {
          cancelAnimationFrame(this.promptFrame);
          this.promptFrame = requestAnimationFrame(() => this.updatePrompt());
        }, { signal: this.events.signal });
        this.sectionOnscreen = false;
        this.visibleActions = new Set();
        this.promptObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.target === this) this.sectionOnscreen = entry.isIntersecting;
            else if (entry.isIntersecting) this.visibleActions.add(entry.target);
            else this.visibleActions.delete(entry.target);
          });
          this.updatePrompt();
        }, { threshold: 0 });
        this.promptObserver.observe(this);
        this.querySelectorAll('[data-rfm-primary-cta], [data-rfm-closing]').forEach(element => this.promptObserver.observe(element));
        this.promptObserver.observe(this.purchaseForm || this.purchaseTarget);
        this.purchaseForm?.querySelectorAll('[type="submit"]').forEach(element => this.promptObserver.observe(element));
      }

      updatePrompt() {
        if (!this.purchasePrompt || !this.promptObserver) return;
        const activeDialog = Array.from(document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"]:not([hidden])')).some(dialog => dialog.getClientRects().length > 0);
        this.purchasePrompt.hidden = !this.mobileQuery.matches || !this.sectionOnscreen || this.visibleActions.size > 0 || Boolean(activeDialog);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        cancelAnimationFrame(this.promptFrame);
        this.events?.abort();
        this.revealObserver?.disconnect();
        this.promptObserver?.disconnect();
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["queenbookshelf"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('restora-queen-murphy-page')) {
  customElements.define('restora-queen-murphy-page', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.motion !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.mediaQuery = matchMedia('(prefers-reduced-motion: reduce)');
      this.controller = new AbortController();
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.remove('rmq-pending');
              this.observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.05 });
        this.querySelectorAll('.rmq-reveal').forEach(el => {
          if (el.getBoundingClientRect().top > innerHeight) el.classList.add('rmq-pending');
          this.observer.observe(el);
        });
      }
      const elements = [...this.querySelectorAll('[data-rmq-parallax]')];
      const update = () => {
        this.frame = null;
        elements.forEach(el => {
          const box = el.getBoundingClientRect();
          const shift = this.mediaQuery.matches ? 0 : Math.max(-8, Math.min(8, (innerHeight / 2 - box.top - box.height / 2) * .025));
          el.style.setProperty('--rmq-shift', shift + 'px');
        });
      };
      const schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(update); };
      window.addEventListener('scroll', schedule, { passive: true, signal: this.controller.signal });
      window.addEventListener('resize', schedule, { passive: true, signal: this.controller.signal });
      this.mediaQuery.addEventListener('change', () => {
        if (this.mediaQuery.matches) this.querySelectorAll('.rmq-pending').forEach(el => el.classList.remove('rmq-pending'));
        schedule();
      }, { signal: this.controller.signal });
      update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["restora-floor-mattress-elite"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('restora-floor-mattress')) {
    customElements.define('restora-floor-mattress', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (!this.isConnected || this.initialized) return;
        this.initialized = true;
        this.events = new AbortController();
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobileQuery = window.matchMedia('(max-width: 989px)');
        this.purchaseForm = this.findPurchaseForm();
        this.purchaseTarget = this.findPurchaseTarget();
        this.addEventListener('click', event => this.onClick(event), { signal: this.events.signal });
        this.motionQuery.addEventListener('change', () => this.setupMotion(), { signal: this.events.signal });
        this.mobileQuery.addEventListener('change', () => this.updatePrompt(), { signal: this.events.signal });
        this.setupMotion();
        this.setupPrompt();
      }

      findPurchaseForm() {
        let variantIds = [];
        try { variantIds = JSON.parse(this.dataset.variantIds || '[]') || []; } catch (_) {}
        const ids = new Set(variantIds.map(String));
        if (!ids.size) return null;
        const forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
        return forms.find(form => {
          if (this.contains(form) || !form.getClientRects().length) return false;
          const variantInput = form.querySelector('[name="id"]');
          return variantInput && ids.has(String(variantInput.value));
        }) || null;
      }

      findPurchaseTarget() {
        const explicitId = (this.dataset.purchaseTarget || '').replace(/^#/, '').trim();
        const explicitTarget = explicitId ? document.getElementById(explicitId) : null;
        if (explicitTarget) return explicitTarget;
        const form = this.purchaseForm;
        if (!form) return null;
        return form.closest('product-info, [data-product-information], .product__info-container, .product-single__meta, .product-single__details, .product__details') || form;
      }

      onClick(event) {
        const link = event.target.closest('[data-rfm-purchase]');
        if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (!this.purchaseTarget?.isConnected) {
          this.purchaseForm = this.findPurchaseForm();
          this.purchaseTarget = this.findPurchaseTarget();
        }
        if (!this.purchaseTarget) return;
        event.preventDefault();
        const target = this.purchaseTarget;
        const offset = parseFloat(getComputedStyle(this).getPropertyValue('--rfm-anchor-offset')) || 120;
        const top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset);
        if (!target.hasAttribute('tabindex') && !target.matches('a, button, input, select, textarea, summary')) {
          target.setAttribute('tabindex', '-1');
          target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
        }
        target.focus({ preventScroll: true });
        window.scrollTo({ top, behavior: this.motionQuery.matches ? 'instant' : 'smooth' });
        if (this.purchasePrompt) this.purchasePrompt.hidden = true;
      }

      setupMotion() {
        this.revealObserver?.disconnect();
        this.classList.remove('rfm--motion');
        if (this.dataset.motion !== 'true' || this.motionQuery.matches || !('IntersectionObserver' in window)) return;
        this.classList.add('rfm--motion');
        this.revealObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('rfm-in-view');
            this.revealObserver.unobserve(entry.target);
          });
        }, { rootMargin: '0px 0px -28px 0px', threshold: 0.06 });
        this.querySelectorAll('[data-rfm-reveal]').forEach(element => this.revealObserver.observe(element));
      }

      setupPrompt() {
        this.purchasePrompt = this.querySelector('[data-rfm-sticky]');
        if (!this.purchasePrompt || !this.purchaseTarget || !('IntersectionObserver' in window)) return;
        document.addEventListener('toggle', () => this.updatePrompt(), { capture: true, signal: this.events.signal });
        document.addEventListener('click', () => {
          cancelAnimationFrame(this.promptFrame);
          this.promptFrame = requestAnimationFrame(() => this.updatePrompt());
        }, { signal: this.events.signal });
        this.sectionOnscreen = false;
        this.visibleActions = new Set();
        this.promptObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.target === this) this.sectionOnscreen = entry.isIntersecting;
            else if (entry.isIntersecting) this.visibleActions.add(entry.target);
            else this.visibleActions.delete(entry.target);
          });
          this.updatePrompt();
        }, { threshold: 0 });
        this.promptObserver.observe(this);
        this.querySelectorAll('[data-rfm-primary-cta], [data-rfm-closing]').forEach(element => this.promptObserver.observe(element));
        this.promptObserver.observe(this.purchaseForm || this.purchaseTarget);
        this.purchaseForm?.querySelectorAll('[type="submit"]').forEach(element => this.promptObserver.observe(element));
      }

      updatePrompt() {
        if (!this.purchasePrompt || !this.promptObserver) return;
        const activeDialog = Array.from(document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"]:not([hidden])')).some(dialog => dialog.getClientRects().length > 0);
        this.purchasePrompt.hidden = !this.mobileQuery.matches || !this.sectionOnscreen || this.visibleActions.size > 0 || Boolean(activeDialog);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        cancelAnimationFrame(this.promptFrame);
        this.events?.abort();
        this.revealObserver?.disconnect();
        this.promptObserver?.disconnect();
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["twincloset"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('restora-murphy-reference')) {

    class RestoraMurphyReference extends HTMLElement {

      connectedCallback() {

        if (this.controller) return;

        this.controller = new AbortController();

        const signal = this.controller.signal;

        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.items = [...this.querySelectorAll('.na-reveal')];

        this.panels = [...this.querySelectorAll('[data-na-parallax]')].filter(panel => panel.querySelector(':scope > img'));

        this.requestFrame = this.requestFrame.bind(this);

        this.setupMotion = this.setupMotion.bind(this);

        this.setupMotion();

        window.addEventListener('scroll', this.requestFrame, { passive: true, signal });

        window.addEventListener('resize', this.requestFrame, { passive: true, signal });

        this.motionQuery.addEventListener('change', this.setupMotion, { signal });

        this.querySelectorAll('.na-faq-item').forEach(item => item.addEventListener('toggle', () => {

          if (item.open) this.querySelectorAll('.na-faq-item').forEach(other => { if (other !== item) other.open = false; });

        }, { signal }));

        document.addEventListener('shopify:block:select', event => {

          if (!(event.target instanceof Element) || !this.contains(event.target)) return;

          event.target.closest('.na-reveal')?.classList.add('is-visible');

        }, { signal });

        if ('ResizeObserver' in window) { this.resizeObserver = new ResizeObserver(this.requestFrame); this.resizeObserver.observe(this); }

        this.requestFrame();

      }

      setupMotion() {

        this.observer?.disconnect();

        this.motion = this.dataset.motion === 'true' && !this.motionQuery.matches;

        if (!this.motion || !('IntersectionObserver' in window) || window.Shopify?.designMode) {

          this.classList.remove('is-animated');

          this.items.forEach(item => item.classList.add('is-visible'));

        } else {

          this.classList.add('is-animated');

          this.observer = new IntersectionObserver(entries => entries.forEach(entry => {

            if (!entry.isIntersecting) return;

            entry.target.classList.add('is-visible');

            this.observer.unobserve(entry.target);

          }), { threshold: .12, rootMargin: '0px 0px -5% 0px' });

          this.items.forEach(item => this.observer.observe(item));

        }

        this.requestFrame();

      }

      requestFrame() {

        if (this.frame || !this.isConnected) return;

        this.frame = requestAnimationFrame(() => {

          this.frame = null;

          if (!this.motion) return;

          this.panels.forEach(panel => {

            const rect = panel.getBoundingClientRect();

            if (rect.bottom < 0 || rect.top > innerHeight) return;

            const speed = parseFloat(panel.dataset.naSpeed || '.06');

            const offset = innerHeight / 2 - (rect.top + rect.height / 2);

            const limit = Math.min(28, rect.height * .07);

            panel.style.setProperty('--na-shift', `${Math.max(-limit, Math.min(limit, offset * speed)).toFixed(2)}px`);

          });

        });

      }

      disconnectedCallback() {

        this.controller?.abort();

        this.observer?.disconnect();

        this.resizeObserver?.disconnect();

        if (this.frame) cancelAnimationFrame(this.frame);

        this.controller = null;

        this.frame = null;

        this.classList.remove('is-animated');

      }

    }

    customElements.define('restora-murphy-reference', RestoraMurphyReference);

  }


  } catch(e) { console.error(e); }
})();
})();
